<template>
  <section class="mx-3 sm:mx-6 py-3 sm:py-4 flex-1">
    <slot />
  </section>
</template>
